import {
  Invalidate,
  LoadingMore,
  QueryError,
  QueryLoaded,
  RequestQuery,
  getUserQueryKey,
} from '../actions/userQueries';

export default function userQueries(state = {}, action) {
  switch (action.type) {
    case RequestQuery: {
      const queryKey = getUserQueryKey(action.queryParams);
      return Object.assign({}, state, {
        [queryKey]: Object.assign({}, state[queryKey], {
          lastUpdated: action.timestamp,
          loading: true,
          loadingMore: false,
          queryParams: action.queryParams,
        }),
      });
    }

    case QueryLoaded: {
      const userIDs = [];
      action.result.users.forEach((user) => {
        userIDs.push(user._id);
      });
      const queryKey = getUserQueryKey(action.queryParams);
      return Object.assign({}, state, {
        [queryKey]: Object.assign({}, state[queryKey], {
          hasNextPage: action.result.hasNextPage,
          lastUpdated: action.timestamp,
          loading: false,
          loadingMore: false,
          queryParams: action.queryParams,
          userIDs,
        }),
      });
    }

    case QueryError: {
      const queryKey = getUserQueryKey(action.queryParams);
      return Object.assign({}, state, {
        [queryKey]: Object.assign({}, state[queryKey], {
          error: action.error,
          lastUpdated: action.timestamp,
          loading: false,
          loadingMore: false,
          queryParams: action.queryParams,
        }),
      });
    }

    case LoadingMore: {
      const queryKey = getUserQueryKey(action.queryParams);
      return Object.assign({}, state, {
        [queryKey]: Object.assign({}, state[queryKey], {
          lastUpdated: action.timestamp,
          loadingMore: true,
          queryParams: action.queryParams,
        }),
      });
    }

    case Invalidate: {
      return {};
    }

    default:
      return state;
  }
}
